import {OwnedItem} from 'models/owned-item';

export class Batch extends OwnedItem {}
